import React, { Component } from 'react'
import { meta } from 'helpers/decorators'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { FilterLabels } from 'containers/filters'
import { apiLabels } from 'helpers/decorators/api'
import LabelsTable from '../../../components/sections/labels/LabelsTable/LabelsTable'

const enhance = compose(
    meta({
      title: 'Labels',
      intlKey: 'pageTitle.labels'
    }),
    apiLabels({
      list: true,
      filter: 'orgLabels'
    }),
    connect(({ auth }) => ({
      activeOrganization: auth.organization
    }), {})
)

class AwardUnitLabels extends Component {
  static propTypes = {
    labels: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired
  }

  render() {
      const {
          activeOrganization
      } = this.props

    return (
        <div>
          <FilterLabels />
          <LabelsTable {...this.props} activeOrganization={activeOrganization} showOrgDetail={false} hideAction />
        </div>
    )
  }
}

export default enhance(AwardUnitLabels)

